import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import '../About/About.css';
import Experiences from "./Experiences";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <div className="project-hero section-hero-left">
          <p className="project-kicker">Know More</p>
          <h1 className="project-heading">
            A builder shaped by scale, research, and product depth.
          </h1>
          <p className="project-subheading">
            A quick snapshot of my background, experience, and the kind of
            engineering problems I enjoy solving.
          </p>
        </div>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 className="section-heading">
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <div className="content-panel content-panel-compact">
              <img src={laptopImg} alt="about" className="img-fluid" />
            </div>
          </Col>
        </Row>
        <h1 className="section-heading">
          Past <strong className="purple">Experiences</strong>
        </h1>
        <Experiences />
      </Container>
    </Container>
  );
}

export default About;
